import { Skeleton } from 'antd'
import * as Flow from '../../pages/Traceability/formStyle'
import { OnboardingHeader } from '../OnboardingHeader'
import * as S from './style'

export function OnboardingSkeleton (): React.ReactElement {
  return <div role='status' aria-label='Carregando configuração'>
    <OnboardingHeader />
    <S.Content>
    <Skeleton.Input active style={{ width: 240, marginBottom: 24 }} />
    <Flow.StepOverview style={{ padding: 16 }}><Skeleton active title={false} paragraph={{ rows: 2 }} /></Flow.StepOverview>
    <Flow.FormPanel>
      <Skeleton active avatar title paragraph={false} />
      <div style={{ margin: '28px 0' }}><Skeleton.Avatar active size={76} shape='circle' /></div>
      <Flow.FieldsGrid>{Array.from({ length: 4 }, (_, index) => <div key={index}>
        <Skeleton.Input active size='small' style={{ width: 100, marginBottom: 8 }} />
        <Skeleton.Input active block />
      </div>)}</Flow.FieldsGrid>
    </Flow.FormPanel>
    </S.Content>
  </div>
}
